import React from 'react';
import './ProfilePageHeader.css';
import {Avatar, Spinner, ScrolledHeader, FancyButton} from '../widgets';
import {connect} from 'react-redux';
import Dropzone from 'react-dropzone';
import {uiActions} from '../chrome';
import editingProfileActions from './editingProfile.actions';
import BioHelper from './BioHelper';
import actions from './profile.actions';
import FancyPill from '../widgets/FancyPill';
import FancyCheckbox from '../widgets/FancyCheckbox';
import confirmActions from '../widgets/confirmation.actions';
import Icon from '../widgets/Icon';
import {Link} from 'react-router-dom';
import {sessionActions} from '../user';
import {sessionUserIsIdentifiable} from '../user/session.selectors';
import {getYouTubeID} from './youtube';

const {
	uploadBackgroundImage,
	uploadAvatarImage,
	profileDragOverBackgroundImage,
	profileDragOutBackgroundImage,
	profileDragOverAvatarImage,
	profileDragOutAvatarImage,
	profileAddFavouritedCount,
	profileSubtractFavouritedCount
} = actions;

const BG_PREFIX = 'linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),';

const isIncomplete = provider =>
	!provider.user.firstname ||
	!provider.user.lastname ||
	!provider.user.location ||
	!provider.category ||
	!provider.profession ||
	!provider.profile.brief;

export const ProfilePageHeader = props => {
	if (!props || !props.provider || !props.provider.user) {
		return null;
	}

	const {
		provider: {
			uuid,
			profession,
			user: {firstname, lastname, uuid: userUuid, location, businessName, badges},
			profile: {
				backgroundPosition = 33,
				backgroundImage,
				avatarImage,
				uniqueName,
				state,
				backgroundYouTube,
				backgroundYouTubeCover,
				includeInSuggestions
			},
			updatingAvatarImage,
			updatingBackgroundImage,
			category,
			subscriptionLevel,
			favouriteCount,
			favouritedCount,
			youTubePanelShown
		},
		screenSize,
		sessionProvider,
		dropBackgroundFile,
		dropAvatarFile,
		dragOverBackground,
		dragOutBackground,
		dragOverAvatar,
		dragOutAvatar,
		draggingOverBackgroundImage,
		draggingOverAvatarImage,
		editDetails,
		editContacts,
		confirmUnapproval,
		approveProfile,
		editable = false,
		isAdmin = false,
		setFavourite,
		favourites,
		sessionUserIsIdentifiable,
		profileToggleYouTubePanel,
		changeBackgroundYouTube,
		setBackgroundYouTubeCover,
		setBackgroundYouTubeFit,
		enableIncludeInSuggestions,
		disableIncludeInSuggestions
	} = props;

	const defaultImageNumber = (Number(uuid.replace(/\D/g, '')) % 10) + 1;

	const isLoggedIn = !!(sessionProvider && sessionProvider.user);
	const isViewingOwn = userUuid === (isLoggedIn && sessionProvider.user.uuid);
	const isFavourite = !!(favourites && favourites[uuid]);

	const backgroundYouTubeID = backgroundYouTube && getYouTubeID(backgroundYouTube);

	return (
		<div className={`ProfilePageHeader ${editable ? 'enabled' : 'disabled'}`}>
			<div
				className="ProfilePageHeader-defaultBackground"
				style={{
					backgroundImage: `url("/img/abstract-${defaultImageNumber}.jpg")`
				}}
			/>
			<Dropzone
				className={`ProfilePageHeader-backdrop ${draggingOverBackgroundImage ? 'over' : ''} ${
					updatingBackgroundImage ? 'updating' : ''
				}`}
				style={{
					backgroundImage: updatingBackgroundImage
						? `${BG_PREFIX}url(${updatingBackgroundImage.preview})`
						: `${BG_PREFIX}url("/api/image/${backgroundImage}")`,
					backgroundPosition: `center ${backgroundPosition}%`
				}}
				onDrop={
					['essentials', 'premium'].indexOf(subscriptionLevel) >= 0 ? dropBackgroundFile : undefined
				}
				accept="image/jpeg, image/png"
				onDragEnter={dragOverBackground}
				onDragLeave={dragOutBackground}
				disabled={!editable}
				disableClick={true}>
				{updatingBackgroundImage && (
					<span
						style={{
							position: 'absolute',
							zIndex: 10,
							fontSize: '200%',
							right: 64,
							bottom: 16,
							overflow: 'hidden'
						}}>
						{Math.round(updatingBackgroundImage.progress * 100)}%
					</span>
				)}
				{updatingBackgroundImage && (
					<div
						style={{
							position: 'absolute',
							opacity: 0.5,
							background: 'white',
							bottom: 0,
							left: 0,
							right: 0,
							top: `${Math.round(updatingBackgroundImage.progress * 100)}%`
						}}
					/>
				)}
			</Dropzone>
			{/* Profile header youtube disabled for now due to mobiles issues */}
			{/* {(backgroundYouTube && ['essentials', 'premium'].indexOf(subscriptionLevel) >= 0 ? (<iframe
				className={`ProfilePageHeader-media ${backgroundYouTubeCover ? 'cover' : 'fit'}`}
				src={`https://www.youtube.com/embed/${backgroundYouTubeID}?rel=0&amp;controls=0&amp;showinfo=0&amp;autoplay=1&amp;mute=1&amp;loop=1&amp;playlist=${backgroundYouTubeID}`}
				frameborder="0"
				allow="autoplay; encrypted-media"
				allowfullscreen
			/>) : undefined} */}
			<div className="ProfilePageHeader-details">
				<div className={`ProfilePageHeader-avatar`}>
					{updatingAvatarImage && (
						<span
							style={{
								position: 'absolute',
								zIndex: 10,
								fontSize: '200%',
								width: screenSize === 'mobile' ? '128px' : '192px',
								height: screenSize === 'mobile' ? '128px' : '192px',
								textAlign: 'center',
								lineHeight: screenSize === 'mobile' ? '128px' : '192px',
								borderRadius: '100%',
								overflow: 'hidden',
								left: 0
							}}>
							{Math.round(updatingAvatarImage.progress * 100)}%
							<div
								style={{
									position: 'absolute',
									opacity: 0.5,
									background: 'white',
									bottom: 0,
									left: 0,
									right: 0,
									height: `${100 - Math.round(updatingAvatarImage.progress * 100)}%`
								}}
							/>
						</span>
					)}
					<Dropzone
						className={`ProfilePageHeader-avatar-dropzone ${
							draggingOverAvatarImage ? 'over' : ''
						} ${updatingAvatarImage ? 'updating' : ''}`}
						onDrop={dropAvatarFile}
						accept="image/jpeg, image/png"
						onDragEnter={dragOverAvatar}
						onDragLeave={dragOutAvatar}
						disabled={!editable}>
						<Avatar
							title={
								isAdmin ? `Upload an image of ${firstname}` : 'Click to upload an image of yourself'
							}
							backgroundImage={updatingAvatarImage ? null : avatarImage}
							backgroundURL={updatingAvatarImage ? updatingAvatarImage.preview : null}
							size={screenSize === 'mobile' ? 128 : 192}>
							{editable && !avatarImage && (
								<div className="ProfilePageHeader-avatar-prompt">
									<span>{isAdmin ? `Add a photo of ${firstname}` : 'Add a photo of yourself'}</span>
								</div>
							)}
						</Avatar>
					</Dropzone>
					{isViewingOwn && subscriptionLevel !== 'none' ? (
						<BioHelper stepKey="avatar" />
					) : (
						undefined
					)}
					{isLoggedIn || favouritedCount ? (
						<div
							className={`ProfilePageHeader-collectionCount ${isFavourite ? 'favourited' : ''}`}
							title={
								favouritedCount || isViewingOwn
									? `${favouritedCount} ${
											favouritedCount === 1 ? 'person has' : 'people have'
									  } added ${firstname || 'New user'}`
									: `Click to add ${firstname} as a favourite`
							}
							onClick={
								!isLoggedIn || isViewingOwn || !sessionUserIsIdentifiable
									? undefined
									: () => setFavourite(uuid, !isFavourite)
							}>
							<Icon name={isFavourite ? 'favorite' : 'favorite_border'} />
							{favouritedCount ? (
								<span className="ProfilePageHeader-collectionCount-count">{favouritedCount}</span>
							) : (
								undefined
							)}
						</div>
					) : (
						undefined
					)}
				</div>
				<div className="ProfilePageHeader-name">
					<h1>
						{firstname || lastname ? `${firstname} ${lastname}` : <em>New user</em>}
						{badges && badges['founders-500'] ? (
							<div
								className="ProfilePageHeader-badge"
								title={`${firstname} is one of the founding 500 providers`}>
								500
							</div>
						) : (
							undefined
						)}
					</h1>
					{screenSize !== 'mobile' && (
						<ScrolledHeader>
							<Avatar backgroundImage={avatarImage} size={32} />
							<span>
								{firstname} {lastname}
							</span>
						</ScrolledHeader>
					)}
					<div className="ProfilePageHeader-usernameWrapper">
						{subscriptionLevel !== 'none' ? (
							<div className="ProfilePageHeader-businessName">{businessName}</div>
						) : (
							undefined
						)}
					</div>
					{profession && subscriptionLevel !== 'none' && (
						<div className="ProfilePageHeader-category">{profession}</div>
					)}
					{category && subscriptionLevel !== 'none' && (
						<div className="ProfilePageHeader-category">{category}</div>
					)}
					{location && location.suburb && (
						<div className="ProfilePageHeader-geo">
							<span className="icon-room" />
							<span className="ProfilePageHeader-name">{location.suburb}</span>
						</div>
					)}
					{editable && (
						<div className="ProfilePageHeader-editable">
							{isViewingOwn && subscriptionLevel !== 'none' && isIncomplete(props.provider) && (
								<div className="ProfilePageHeader-incomplete">
									<span className="icon icon-warning" />
									<span>
										You are not yet shown in search results. <br /> Please use the{' '}
										<em>Edit profile details</em> button above to complete your profile.
									</span>
								</div>
							)}

							{!isViewingOwn && subscriptionLevel !== 'none' ? (
								<p>
									<FancyCheckbox
										checked={state === 'approved'}
										onChange={state === 'approved' ? confirmUnapproval : approveProfile}
									/>
									<span>Approve user's profile</span>
								</p>
							) : (
								undefined
							)}
							{!isViewingOwn && subscriptionLevel !== 'none' ? (
								<p>
									<FancyCheckbox
										checked={includeInSuggestions}
										onChange={
											includeInSuggestions
												? disableIncludeInSuggestions
												: enableIncludeInSuggestions
										}
									/>
									<span>Include in suggestions</span>
								</p>
							) : (
								undefined
							)}
						</div>
					)}
				</div>
			</div>
			{/* BACKRGOUND YOUTUBE DISABLED FOR NOW */}
			{/* {editable && (['essentials', 'premium'].indexOf(subscriptionLevel) >= 0) && (
				<button
					className={`ProfilePageHeader-youtubeedit`}
					title={isAdmin ? `Set a background youtube video for ${firstname}` : 'Set a background youtube video'}
					onClick={profileToggleYouTubePanel}
				>
					<span
						className="icon icon-personal_video"
					/>
				</button>
			)} */}
			{editable && ['essentials', 'premium'].indexOf(subscriptionLevel) >= 0 && (
				<Dropzone
					className={`ProfilePageHeader-photoedit ${draggingOverBackgroundImage ? 'over' : ''} ${
						updatingBackgroundImage ? 'updating' : ''
					}`}
					onDrop={dropBackgroundFile}
					accept="image/jpeg, image/png"
					onDragEnter={dragOverBackground}
					onDragLeave={dragOutBackground}
					disabled={!editable}>
					{!updatingBackgroundImage && (
						<span
							className="icon icon-photo_camera"
							title={
								isAdmin
									? `Upload a background image for ${firstname}`
									: 'Upload an image file as your background'
							}
						/>
					)}
					{updatingBackgroundImage && <Spinner />}
				</Dropzone>
			)}
			{/* BACKGROUND YOUTUBE DISABLED FOR NOW */}
			{/* {editable && (['essentials', 'premium'].indexOf(subscriptionLevel) >= 0) ? (
				<div className={`ProfilePageHeader-youTubePanel ${youTubePanelShown ? 'shown': 'hidden'}`}>
					<h3>YouTube video</h3>
					<input
						type="text"
						value={backgroundYouTube}
						placeholder="Paste YouTube video URL here (e.g. https://youtu.be/_QdPW8JrYzQ)"
						onChange={changeBackgroundYouTube}
					/>
					<FancyPill items={[
						{
							title: 'Cover header',
							text: 'Cover header',
							selected: backgroundYouTubeCover,
							onClick: setBackgroundYouTubeCover
						}, {
							title: 'Fit within header',
							text: 'Fit within header',
							selected: !backgroundYouTubeCover,
							onClick: setBackgroundYouTubeFit
						}
					]} />
					<p>NOTE; Will not appear on mobile due to lack of autoplay.</p>
					<p>Instructions;</p>
					<ol>
						<li>Open your video on <a href="https://www.youtube.com" target="blank" rel="noreferrer">https://www.youtube.com</a></li>
						<li>Click or tap the <em>Share</em> button</li>
						<li>Under <em>Share a link</em>, click or tap <em>Copy</em> from the input field</li>
						<li>Paste the link above <em>e.g. https://youtu.be/inCPtPGhTxg</em></li>
					</ol>
					<FancyButton onClick={profileToggleYouTubePanel}>Done</FancyButton>
				</div>
			) : undefined} */}
		</div>
	);
};

const ConnectedProfilePageHeader = connect(
	({profile, ui, session} = {}) => ({
		provider: profile,
		sessionProvider: session && session.current,
		screenSize: ui.screenSize,
		editable:
			session.current &&
			session.current.user &&
			profile &&
			(session.current.user.admin || session.current.provider.uuid === profile.uuid),
		isAdmin: session.current && session.current.user && profile && session.current.user.admin,
		favourites: session && session.favourites,
		sessionUserIsIdentifiable: sessionUserIsIdentifiable({session})
	}),
	dispatch => ({
		profileToggleYouTubePanel: () => dispatch(actions.profileToggleYouTubePanel()),
		setFavourite: (providerUuid, isFav) => {
			dispatch(sessionActions.setFavourite(providerUuid, isFav));
			dispatch(isFav ? profileAddFavouritedCount() : profileSubtractFavouritedCount());
		},
		editDetails: () => {
			dispatch(editingProfileActions.init());
			dispatch(uiActions.uiModal('profile-edit-details'));
		},
		editContacts: () => {
			dispatch(actions.profileEditContacts());
			dispatch(uiActions.uiModal('profile-edit-contacts'));
		},
		dragOverBackground: () => dispatch(profileDragOverBackgroundImage()),
		dragOutBackground: () => dispatch(profileDragOutBackgroundImage()),
		dropBackgroundFile: acceptedFiles =>
			acceptedFiles[0] && dispatch(uploadBackgroundImage(acceptedFiles[0])),
		dragOverAvatar: () => dispatch(profileDragOverAvatarImage()),
		dragOutAvatar: () => dispatch(profileDragOutAvatarImage()),
		dropAvatarFile: acceptedFiles =>
			acceptedFiles[0] && dispatch(uploadAvatarImage(acceptedFiles[0])),
		confirmUnapproval: () =>
			dispatch(
				confirmActions.open({
					title: `Do you really want to unapprove this profile?`,
					message:
						'This will affect how this profile appears in search results, and they will receive an email.',
					onConfirm: () =>
						dispatch(
							actions.persistProviderField({
								profile: {
									state: 'unapproved'
								}
							})
						),
					data: 'unapproval'
				})
			),
		approveProfile: () =>
			dispatch(
				actions.persistProviderField({
					profile: {
						state: 'approved'
					}
				})
			),
		changeBackgroundYouTube: e =>
			dispatch(
				actions.persistProviderField({
					profile: {
						backgroundYouTube: e.target.value
					}
				})
			),
		setBackgroundYouTubeCover: () =>
			dispatch(
				actions.persistProviderField({
					profile: {
						backgroundYouTubeCover: true
					}
				})
			),
		setBackgroundYouTubeFit: () =>
			dispatch(
				actions.persistProviderField({
					profile: {
						backgroundYouTubeCover: false
					}
				})
			),
		enableIncludeInSuggestions: () =>
			dispatch(
				actions.persistProviderField({
					profile: {
						includeInSuggestions: true
					}
				})
			),
		disableIncludeInSuggestions: () =>
			dispatch(
				actions.persistProviderField({
					profile: {
						includeInSuggestions: false
					}
				})
			)
	})
)(ProfilePageHeader);

export default ConnectedProfilePageHeader;



// WEBPACK FOOTER //
// ./src/profile/ProfilePageHeader.js